import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import {
  PermissionGuard,
  RequiredRolesAnnotation,
} from 'src/app/core/guards/permission.guard';
import { HomePageComponent } from './home/home.component';
import { InternalLayoutComponent } from './internal.component';
import { SettingsShellPageComponent } from './settings/pages/settings.component';
import { PageShellAnnotation } from 'src/app/pages/route-transitions';

export const InternalRoutes: Routes = [
  {
    path: 'onboarding',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./onboarding/onboarding.routes').then(m => m.ONBOARDING_ROUTES),
  },
  {
    path: 'subscription-checkout',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./settings/pages/organization/subscription/checkout/checkout.module').then(
        m => m.SubscriptionCheckoutModule
      ),
  },
  {
    path: 'subscription-change',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./settings/pages/organization/subscription/change/change.module').then(
        m => m.SubscriptionChangeModule
      ),
  },
  {
    path: '',
    component: InternalLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        component: HomePageComponent,
        data: {
          title: 'menu.dashboard',
          icon: 'squares-four',
        },
      },
      {
        path: 'incidents',
        data: {
          title: 'menu.incidents',
          icon: 'fire',
          [RequiredRolesAnnotation]: ['incidents.reader'],
        },
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./incidents/incidents.module').then(m => m.IncidentsModule),
      },
      {
        path: 'alerts',
        data: {
          title: 'menu.alerts',
          icon: 'warning',
          [RequiredRolesAnnotation]: ['alerts.reader'],
        },
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./alerts/alerts.module').then(m => m.AlertsModule),
      },
      {
        path: 'monitors',
        data: {
          title: 'menu.monitors',
          icon: 'pulse',
          [RequiredRolesAnnotation]: ['monitors.reader'],
        },
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./monitors/monitors.module').then(m => m.MonitorsModule),
      },
      {
        path: 'statuspages',
        data: {
          title: 'menu.statuspages',
          icon: 'browser',
          [RequiredRolesAnnotation]: ['statuspages.reader'],
        },
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./statuspages/statuspages.module').then(
            m => m.StatuspageModule
          ),
      },
      {
        path: 'services',
        data: {
          title: 'menu.services',
          icon: 'diamonds-four',
          [RequiredRolesAnnotation]: ['services.reader'],
        },
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./services/services.module').then(m => m.ServicesModule),
      },
      {
        path: 'teams',
        data: {
          title: 'menu.teams',
          icon: 'users-three',
          [RequiredRolesAnnotation]: ['teams.reader'],
        },
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./teams/teams.module').then(m => m.TeamsModule),
      },
      {
        path: 'settings',
        component: SettingsShellPageComponent,
        loadChildren: () =>
          import('./settings/settings.module').then(m => m.SettingsModule),
        data: {
          title: 'menu.settings',
          icon: 'gear',
          [PageShellAnnotation]: true,
        },
      },
    ],
  },
];
